import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { auditorSimulationKey, continuePathQueryParam, tenantIdQueryParam, tokenQueryParam } from '../../constants';
import { AuthService } from '../auth/auth.service';
import { TenantFacadeService } from '../facades';
import { FirebaseWrapperService } from '../firebase-wrapper/firebase-wrapper.service';
import { TenantSubDomainExtractorService } from '../tenant-sub-domain-extractor/tenant-sub-domain-extractor.service';
import { WindowHelperService } from '@anecdotes/utils';
import { browserSessionPersistence } from '@firebase/auth';
import { AuditorSimulationService } from '../auditor-simulation/auditor-simulation.service';

@Injectable()
export class AuthCallbackGuard {
  constructor(
    private authService: AuthService,
    private tenantFacade: TenantFacadeService,
    private firebaseWrapper: FirebaseWrapperService,
    private windowHelper: WindowHelperService,
    private tenant: TenantSubDomainExtractorService,
    private router: Router,
    private auditorSimulationService: AuditorSimulationService,
  ) {}

  async canActivate(route: ActivatedRouteSnapshot, _: RouterStateSnapshot): Promise<boolean> {
    try {
      const simulation = route.queryParams[auditorSimulationKey];
      const token = route.queryParams[tokenQueryParam];
      const continuePath = route.queryParams[continuePathQueryParam];

      if (simulation) {
        const tenantId = route.queryParams[tenantIdQueryParam];

        this.auditorSimulationService.changeAppAndSetSessionStorageKey();
        this.firebaseWrapper.setTenantId(tenantId);

        await this.authService.signInWithTokenAsync(token, browserSessionPersistence);
        await this.router.navigate([`/${continuePath}`]);
      } else {
        const currentTenant = await this.tenantFacade.getCurrentTenantAsync();
        this.firebaseWrapper.setTenantId(currentTenant.tenant_id);
        await this.authService.signInWithTokenAsync(token);
        this.windowHelper.getLocation().href = continuePath || '';
      }
    } catch {
      const tenantSignInUrl = this.tenant.getTenantSignInUrl();
      this.windowHelper.openUrl(tenantSignInUrl);
    }

    return false;
  }
}
